import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AuthService } from './auth.service';

export const phasedMsalGuard: CanActivateFn = (route, state) => {
  if (inject(AuthService).hasAccounts()) {
    return true;
  }
  return inject(MsalGuard).canActivate(route, state);
};
